export const environment = {
  production: true,
  apiBaseUrl: "https://app.processeye.wideum.com"
};
